import { Box, Drawer } from '@mui/material';
import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import Logo from '../../Logo';
import NavSection from '../../NavSection';
import sidebarConfig from '../../../layouts/dashboard/SidebarConfig';

export default function SidebarMobileDrawer({ open, setOpen, alertMetas, setAlertMetas }) {
  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <Drawer
      BackdropProps={{ 'data-testid': 'sidebar-backdrop' }}
      data-testid="sidebar-small-screen"
      open={open}
      onClose={handleDrawerClose}
      anchor="left"
      sx={{
        '& .MuiDrawer-paper': {
          // borderRadius: '0px 20px 20px 0px',
          overflow: 'hidden'
        }
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          // padding: '20px',
          width: '65px',
          height: '100%'
        }}
      >
        <Box sx={{ px: 2.5, py: 3 }}>
          <Box component={RouterLink} to="/" sx={{ display: 'inline-flex' }}>
            <Logo sx={{ width: '30px' }} />
          </Box>
        </Box>
        <NavSection navConfig={sidebarConfig} />
      </Box>
    </Drawer>
  );
}
